import { isUseProductionEnv } from '@/constants/is-use-production-env';
import { fetchClientIp } from './fetch-client-ip';

export const submitProductTrackData = async product => {
  if (!product) return;

  try {
    const productPrice = product?.price_range?.maximum_price;

    if (isUseProductionEnv) {
      fetchClientIp().then(currentIp => {
        fetch('/api/pinterest-page-visit', {
          method: 'POST',
          body: JSON.stringify({
            product,
            productPrice,
            ip: currentIp,
          }),
        });
      });
    }
  } catch (err) {
    console.error('Pinterest conversion error:', err);
  }

  try {
    const productPrice = product?.price_range?.maximum_price;

    if (product) {
      window.dataLayer &&
        window.dataLayer.push({
          ecommerce: null,
        });
      const categoryName = product?.categories?.[0]?.name || product?.categories?.[0]?.breadcrumbs?.[0]?.category_name || '';

      const ga4Payload = {
          event: 'view_item',
          ecommerce: {
            currency: productPrice?.final_price.currency,
            value: productPrice?.final_price.value,
            items: [
              {
                item_name: product?.name,
                item_id: product?.sku,
                item_category: categoryName,
                price: productPrice?.final_price.value,
                quantity: 1,
              },
            ],
          },
      };
      console.log('👉 [GA4 Event] view_item triggered', ga4Payload);
      window.dataLayer && window.dataLayer.push(ga4Payload);

      window.pintrk &&
        window.pintrk('track', 'pagevisit', {
          line_items: [
            {
              product_name: product?.name,
              product_id: product?.uid,
              product_category: null,
              product_price: productPrice?.final_price.value,
              product_brand: 'kingsyard',
            },
          ],
        });

      window.fbq &&
        window.fbq('track', 'ViewContent', {
          content_ids: [product.sku],
          content_category: null,
          content_name: product.name,
          content_type: 'product',
          contents: [
            {
              product_name: product.name,
              product_id: product.uid,
              product_category: null,
              product_price: productPrice?.final_price.value,
              product_brand: 'kingsyard',
            },
          ],
          currency: productPrice?.final_price.value,
          value: productPrice?.final_price.value,
        });
    }
  } catch (err) {
    console.error(err);
  }
};
